import { Dayjs } from 'dayjs';

export const isInvalidDate = (date: Dayjs, formate = 'MMM D, YYYY') =>
  date?.format(formate) === 'Invalid Date' || date == null;
